import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueRouter from 'vue-router';
import routes from './routes';
import { post, get } from './common/request';
import global_ from './common/Global';
import VueClipboard from 'vue-clipboard2';


Vue.config.productionTip = false;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$Global = global_;

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(VueRouter);
Vue.use(VueClipboard);
const router = new VueRouter({
    // mode: 'history',
    base: "/",
    routes
});

 
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
